<template>
    <BModal ref="modal" :title="$t('cameraReaders.title')" centered scrollable no-close-on-backdrop header-class="modal-title" modal-class="no-border-modal" @hidden="onHidden">
        <p v-if="readers.length === 0" class="mb-0">{{ $t('cameraReaders.none') }}</p>
        <template v-else>
            <div class="form-check mb-2">
                <input id="camera-readers-all" class="form-check-input" type="checkbox" :checked="allSelected" @change="selectAll($event.target.checked)">
                <label class="form-check-label fw-bold text-muted" for="camera-readers-all">{{ $t('video.selectAll') }}</label>
            </div>
            <hr class="my-2">
            <div v-for="item in readers" :key="item.reader.key" class="form-check mb-2">
                <input :id="`camera-reader-${item.reader.key}`" class="form-check-input" type="checkbox" :value="item.reader.key" v-model="selected">
                <label class="form-check-label" :for="`camera-reader-${item.reader.key}`">
                    <span class="fw-bold text-primary">{{ item.label }}</span>
                    <span class="d-block font-13 text-muted">{{ item.hubLabel }}</span>
                </label>
            </div>
        </template>
        <template #footer>
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="close(null)">{{ $t('common.cancel') }}</button>
                <button type="button" class="btn btn-primary ms-2" :disabled="selected.length === 0" @click="close(selectedReaders)">{{ $t('common.ok') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { computed, ref } from 'vue';

// Picks one or several readers of the facility not linked to the camera yet.
// show() resolves with the selected readers in the facility order, or null when cancelled.
export default {
    name: 'CameraReadersModal',
    components: {
        BModal
    },
    setup() {
        const modal = ref(null);
        const readers = ref([]);
        const selected = ref([]);
        let resolver = null;

        const show = (availableReaders) => {
            readers.value = availableReaders;
            selected.value = [];
            modal.value.show();
            return new Promise(resolve => { resolver = resolve; });
        };

        const close = (result) => {
            const resolve = resolver;
            resolver = null;
            modal.value.hide();
            if (resolve) resolve(result);
        };

        const onHidden = () => {
            if (resolver) close(null);
        };

        const allSelected = computed(() => readers.value.length > 0 && selected.value.length === readers.value.length);

        const selectAll = (value) => {
            selected.value = value ? readers.value.map(r => r.reader.key) : [];
        };

        const selectedReaders = computed(() => readers.value.filter(r => selected.value.includes(r.reader.key)));

        return {
            modal,
            readers,
            selected,
            allSelected,
            selectAll,
            selectedReaders,
            show,
            close,
            onHidden,
        };
    }
}
</script>
